function PackageMaster() {
    return (
      <>
        <div className="font-bold text-lg mb-16">PackageMaster</div>
      </>
    );
  }
  
  export default PackageMaster;